/**
 *
 * UserDisciplineFilter
 *
 */
import { UserDisciplinePicker } from 'app/components/pickers/AutocompletePickers/UserDisciplinePicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const UserDisciplineFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <UserDisciplinePicker
      value={props.value as Entity<number> | undefined}
      onChange={handleOnChange}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      size="small"
      ariaLabel={props.label}
      id={props.id}
    />
  );
};
export default UserDisciplineFilter;
